import { HttpClient } from '@angular/common/http';
import BigNumber from 'bignumber.js';
import { tap } from 'rxjs/operators';
import { Base } from '../base';

export class Settlements extends Base {
  constructor(protected httpClient: HttpClient, private parent: string) {
    super(httpClient, `${parent}/settlements`);
  }

  query(params?: any) {
    return this.api.query(params).pipe(
      tap((json) => json.settlements.forEach((record: any) => this.processRecord(record)))
    );
  }

  private processRecord(record: any) {
    record.openInterests = new BigNumber(record.openInterests).fromDecimal();
    record.settleFee = new BigNumber(record.settleFee).fromDecimal();
    record.tradeFee = new BigNumber(record.tradeFee).fromDecimal();
    record.settledPrice = new BigNumber(record.settledPrice).fromDecimal();
  }
}
